import script from "./HelpSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpSelection.vue?vue&type=script&setup=true&lang=js"

import "./HelpSelection.vue?vue&type=style&index=0&id=6e9aa8be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9aa8be"]])

export default __exports__